import React, { useEffect, useState } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { useParams } from "react-router-dom";

import CustomInput from "../../UI/PageInput/CustomInput";
import CustomDescriptionInput from "../../UI/PageInput/CustomDescriptionInput";
import CustomFileInput from "../../UI/PageInput/CustomFileInput";
import SelectedImagesBox from "./SelectedImagesBox";
import CenteredHeading from "../../UI/headingsUI/CenteredHeading";
import GrayButton from "../../UI/buttonUI/GrayButton";
import ExpenseViewDialog from "../../UI/viewDialogs/expense/ExpenseViewDialog";
import UseDialogBox from "../../../CustomHooks/UseDialogBox";
import ImageSlider from "../../UI/viewDialogs/ImageSlider";
import { getCompressImage } from "../../../functions/getCompressImage";
import PrimaryButton from "../../UI/buttonUI/PrimaryButton";
import { CirclePlus } from "lucide-react";

const AddLoanRepayment = ({ sendData, loading, successResponse }) => {
  const { showDialogBox, setShowDialogBox } = UseDialogBox();
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();
  const [openViewDialog, setViewDialog] = useState(false);
  const { name, id, loanBalance } = useParams();

  const {
    register,
    handleSubmit,
    watch,
    control,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      pictures: [], // Initialize pictures as an empty array
    },
  });
  const pic = watch("pictures");
  let files = watch("files");

  const { append, remove } = useFieldArray({
    control,
    name: "files",
  });

  useEffect(() => {
    getCompressImage(pic, append);
  }, [pic]);

  const onSubmit = (data) => {
    const formData = {
      category_id: 3,
      receiver_id: 1,
      user_id: id,
      ...data,
    };
    sendData(formData, reset);
  };
  const openImageSlider = () => {
    setViewDialog(false);
    setShowDialogBox(true);
    setImageSliderPics(successResponse.pictureList);
  };

  const closeImageSlider = () => {
    setViewDialog(true);
    setShowDialogBox(false);
  };

  // show success dialog on api response
  useEffect(() => {
    if (successResponse) {
      setViewDialog(true);
    }
  }, [successResponse]);

  return (
    <div className="form-container">
      <CenteredHeading title="Add Loan Repayment" />
      <div className="formDetails">
        <p>
          <strong>User Name</strong> : {name}
        </p>
        <p>
          <strong>User Id</strong> : {id}
        </p>
        <p>
          <strong>Current Loan</strong> : ₹{loanBalance}
        </p>
      </div>
      <form
        className="form-border max-w-5xl mx-auto"
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
      >
        <div className="flex flex-wrap">
          <div className="leftCol">
            <CustomInput
              type="number"
              name="amount"
              labelText="Amount *"
              placeholder="Enter"
              register={{
                ...register("amount", {
                  required: "Please Enter an amount",
                  min: {
                    value: 1,
                    message: "Amount should be greater than 0",
                  },
                  max: {
                    value: loanBalance,
                    message:
                      "Amount should be lower than user's current loan balance",
                  },
                }),
              }}
              error={errors.amount}
            />
            <CustomDescriptionInput
              name="description"
              labelText="Description *"
              register={{
                ...register("description", {
                  required: "Please Enter Description",
                }),
              }}
              error={errors.description}
            />
          </div>
          <div className="rightCol">
            <>
              <CustomFileInput
                name="pictures"
                placeholder="Add Image* (jpg, png)"
                accept=".png, .jpg, image/png, image/jpeg"
                setValue={setValue}
                register={{
                  ...register("pictures", {
                    required: files
                      ? files.length === 0
                        ? "Please choose a file"
                        : false
                      : "Please choose a file",
                  }),
                }}
                multiple={true}
                error={errors.pictures}
              />
              <SelectedImagesBox
                errors={errors.pictures}
                selectedImages={files}
                setValue={setValue}
                name="pictures"
                remove={remove}
              />
            </>
          </div>
        </div>
        <div className="addLoanBtnWrap">
          <p className="addWrap">
            <PrimaryButton
              btnText={!loading ? "Add Loan Repayment" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
            />
          </p>
          <p className="grayWrap">
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
          </p>
        </div>
      </form>
      {openViewDialog && (
        <ExpenseViewDialog
          viewDetails={successResponse}
          successMsg="Loan Repayment Successfully Created!"
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
        />
      )}
      {showDialogBox && (
        <ImageSlider
          title="Expense Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </div>
  );
};
export default AddLoanRepayment;
